import React from 'react';
import Icon from '../../../components/AppIcon';

const AuditProgressDashboard = () => {
  const progressData = [
    {
      id: 'overall',
      title: 'Overall Progress',
      completed: 342,
      total: 456,
      percentage: 75,
      color: 'bg-primary',
      icon: 'Target'
    },
    {
      id: 'departments',
      title: 'By Department',
      completed: 8,
      total: 12,
      percentage: 67,
      color: 'bg-accent',
      icon: 'Building2'
    },
    {
      id: 'rooms',
      title: 'By Room',
      completed: 23,
      total: 28,
      percentage: 82,
      color: 'bg-success',
      icon: 'MapPin'
    },
    {
      id: 'asset-types',
      title: 'By Asset Type',
      completed: 15,
      total: 18,
      percentage: 83,
      color: 'bg-warning',
      icon: 'Package'
    }
  ];

  const departmentProgress = [
    { name: 'IT Department', completed: 45, total: 52, percentage: 87 },
    { name: 'Finance', completed: 28, total: 35, percentage: 80 },
    { name: 'HR', completed: 22, total: 30, percentage: 73 },
    { name: 'Operations', completed: 38, total: 48, percentage: 79 },
    { name: 'Marketing', completed: 15, total: 20, percentage: 75 }
  ];

  return (
    <div className="space-y-6">
      {/* Main Progress Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {progressData?.map((item) => (
          <div key={item?.id} className="bg-card border border-border rounded-lg p-6 shadow-subtle">
            <div className="flex items-center justify-between mb-4">
              <div className={`w-10 h-10 ${item?.color} rounded-lg flex items-center justify-center`}>
                <Icon name={item?.icon} size={20} color="white" />
              </div>
              <span className="text-2xl font-bold text-card-foreground">{item?.percentage}%</span>
            </div>
            <h3 className="font-medium text-card-foreground mb-2">{item?.title}</h3>
            <div className="flex items-center justify-between text-sm text-muted-foreground mb-3">
              <span>{item?.completed} of {item?.total}</span>
              <span>{item?.total - item?.completed} remaining</span>
            </div>
            <div className="w-full bg-muted rounded-full h-2">
              <div 
                className={`${item?.color} h-2 rounded-full transition-all duration-300`}
                style={{ width: `${item?.percentage}%` }}
              />
            </div>
          </div>
        ))}
      </div>
      {/* Department Progress Detail */}
      <div className="bg-card border border-border rounded-lg p-6 shadow-subtle">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-card-foreground">Department Progress</h3>
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Clock" size={16} />
            <span>Last updated: Aug 19, 2025 4:27 AM</span>
          </div>
        </div>
        <div className="space-y-4">
          {departmentProgress?.map((dept, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex-1">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium text-card-foreground">{dept?.name}</span>
                  <span className="text-sm text-muted-foreground">
                    {dept?.completed}/{dept?.total} ({dept?.percentage}%)
                  </span>
                </div>
                <div className="w-full bg-muted rounded-full h-2">
                  <div 
                    className="bg-primary h-2 rounded-full transition-all duration-300"
                    style={{ width: `${dept?.percentage}%` }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AuditProgressDashboard;